var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04545 17.5C4.04545 18.6505 3.208 19.5 2.27273 19.5C1.33745 19.5 0.5 18.6505 0.5 17.5C0.5 16.3495 1.33745 15.5 2.27273 15.5C3.208 15.5 4.04545 16.3495 4.04545 17.5Z",
    fill: "#93FEB7",
    stroke: "#93FEB7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4545,
    width: 4.54545,
    height: 20,
    rx: 2.27273,
    fill: "#7F6BF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "#7F6BF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6364,
    y: 5,
    width: 4.54545,
    height: 15,
    rx: 2.27273,
    fill: "#7F6BF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalFull);
export default __webpack_public_path__ + "static/media/signal_full.1ccbbbb7c5bec2862bacbb5c2316742d.svg";
export { ForwardRef as ReactComponent };